import { defineCollectionStore } from '@/utils/defineCollectionStore';

export const useEventsStore = defineCollectionStore({
	id: 'events',
	endpoint: '/api/events',
	dataKey: 'events',
	wrapRecords: true,
	trackLastFetched: true,
	errorLabel: 'Fetch Events Error: ',
	fetchName: 'fetchEvents',
	archive: {
		toggleName: 'toggleArchivedEvents',
		archivedDataKey: 'archivedEvents',
		archivedFetchName: 'fetchArchivedEvents',
		archivedEndpoint: (year) => `/api/archive/${year}/events`,
		getters: {
			eventsData: { role: 'data', fallback: () => ({ records: [] }) },
		},
	},
	byId: {
		actionName: 'fetchEventById',
		// Verbatim quirk: archived event lookups are hardcoded to the 2023 archive, regardless of `year`.
		endpoint: (id, isArchived) => (isArchived ? `/api/archive/2023/events/${id}` : `/api/events/${id}`),
	},
});
